import axios from "axios";

export const ExamKeyApi = async (questionSubType, questionType, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/exam/key?";

    const endpoint = `${BASED_URL}${path}questionSubType=${questionSubType}&questionType=${questionType}&token=${token}`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export default ExamKeyApi;
